import { Education } from 'prismic-types';

import { DateTime } from 'components/date/Date';
import { NewsHero } from 'components/news-hero/NewsHero';
import { RegularOrCroppableImage } from 'components/picture/RegularOrCroppablePicture';
import { asText } from 'components/rich-text/RichText';

import { generateImageSizes } from 'utils/cleverCropping';

type Props = {
  data: Education;
};

export const EducationContainer = ({ data }: Props) => {
  const { title, seo_title, image } = data;

  const published = data.published ?? data._meta.firstPublicationDate ?? null;

  return (
    <NewsHero
      image={
        <RegularOrCroppableImage
          image={image}
          componentSizes={generateImageSizes({
            ratio: 1 / 2,
            wide: 1200,
          })}
        />
      }
      date={published && <DateTime dateString={published} />}
      title={asText(title ?? seo_title)}
    />
  );
};
